<template>
  <div>
    <div class="btm-tab van-hairline--top-bottom van-tabbar van-tabbar--fixed pad-top-5 pad-btm-5">
      <div v-for="ele in btnList" :key="ele.cmd" :class="ele.style || 'text-primary'"
           class="van-tabbar-item" @click="handleCmd(ele)">
        <div class="van-tabbar-item__icon">
          <i :class="ele.icon"></i>
        </div>
        <div class="van-tabbar-item__text">{{ele.text}}</div>
      </div>
    </div>

    <van-action-sheet v-model="showMoreBtn" class="bord-top"
                      :actions="moreBtnList" @select="handleCmd"
                      cancel-text="取消" close-on-click-action
                      @cancel="showMoreBtn=false"></van-action-sheet>
  </div>
</template>

<script>
  import {commonConfig} from "../../../config/common"

  const btnStyle = { // 相关样式与icon
    cancelMt: {
      icon: "iconfont icon-guanbi-circle",
      style: "text-danger"
    },
    endMt: {
      icon: "iconfont icon-jieshu",
      style: "text-danger"
    },
    editMt: {
      icon: "iconfont icon-edit"
    },
    delayMt: {
      icon: "iconfont icon-shiduan"
    },

    accept: {
      icon: "iconfont icon-correct",
      style: "text-success"
    },
    undetermined: {
      icon: "iconfont icon-bangzhu"
    },
    reject: {
      icon: "iconfont icon-jinyong",
      style: "text-danger"
    },

    more: {
      icon: "iconfont icon-gengduo-circle",
      style: "text-hv"
    }
  };

  export default {
    props: {
      list: Array,
      more: Array,
    },
    data() {
      return {
        showMoreBtn: false,
      }
    },
    computed: {
      sysFormTitles() {
        return this.$store.state.formTitles
      },
      btnList() {
        return this.list.map(k => ({ // 渲染更多button
          ...(btnStyle[k] || {}),
          cmd: k,
          text: commonConfig.mtBtnMap[k],
        })).concat(this.more.length ? [{
          ...btnStyle['more'],
          cmd: "more",
          text: "会控/服务"
        }] : [])
      },
      moreBtnList() {
        return this.more.map(k => ({
          cmd: k,
          name: this.sysFormTitles[k] || commonConfig.mtBtnMap[k],
        }))
      },
    },
    mounted() {
    },
    methods: {
      handleCmd(doc) {
        if (doc.cmd === 'more') { // 传递button信息
          this.showMoreBtn = true;
          return
        }
        this.$emit('handle-cmd', doc.cmd)
      },
    }
  }
</script>

<style lang="less">
  .btm-tab .iconfont {
    font-size: 18px;
    font-weight: bold;
  }
</style>
